import { useState, useEffect } from 'react'
import { getEventDailyInsight } from '../core/_requests'
import { EventDailyInsightModel } from '../core/_models'

export function useEventDailyInsight() {
    const [data, setData] = useState<EventDailyInsightModel | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<unknown>(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const response = await getEventDailyInsight()
                setData(response.data)
            } catch (err) {
                setError(err)
                console.error('Failed to fetch daily insight:', err)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    return { data, loading, error }
}
